import { render, staticRenderFns } from "./PersonalChatSetting.vue?vue&type=template&id=7aab3b94&scoped=true&"
import script from "./PersonalChatSetting.vue?vue&type=script&lang=js&"
export * from "./PersonalChatSetting.vue?vue&type=script&lang=js&"
import style0 from "./PersonalChatSetting.vue?vue&type=style&index=0&id=7aab3b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aab3b94",
  null
  
)

export default component.exports